import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Button, Row, Col, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faInfo,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from 'sweetalert';

import { withRouter } from 'react-router-dom';


const { SearchBar } = Search;

const defaultSorted = [
    {
        dataField: "idtutor",
        order: "asc",
    },
];

const mapStateToProps = (state) => {
    //console.log("Javier -------> Se carga TableComponent|MapStateToProps ");

    return {
        getColegiaturasList: state.ColegiaturasReducer.getColegiaturasList,
        errorColegiaturasList: state.ColegiaturasReducer.errorColegiaturasList,
    };

};

function columnFormatter(cell, row) { return (<span className="font-12">{cell}</span>); }

function headFormatter(column, colIndex) { return (<strong >{column.text}</strong>); }

function columnFormatter2(cell, row) {
    //console.log("SE CARGAN CON LOS MESES--------->" + cell);
    if (cell == "0") {
        return ("");
    } else {
        return (<><i className="icon-user-following text-success"></i> <span className="font-8">{cell}</span></>);
    }

    
}

const ColegiaturasTabla = (props) => {
    //console.log("Javier -------> Se carga TableComponent | PROPS");


    const columns = [
        {
            dataField: "idtutor",
            text: "ID",
            sort: true,
            headerStyle: () => {
                return { width: "5%", color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombrecompleto",
            text: "Alumno",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "concepto",
            text: "Concepto",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "agostopreciopago",
            text: "Agosto",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "septiembrepreciopago",
            text: "Septiembre",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },    
        {
            dataField: "octubrepreciopago",
            text: "Octubre",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "noviembrepreciopago",
            text: "Noviembre",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "diciembrepreciopago",
            text: "Diciembre",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "eneropreciopago",
            text: "Enero",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "febreropreciopago",
            text: "Febrero",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "marzopreciopago",
            text: "Marzo",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "abrilpreciopago",
            text: "Abril",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "mayopreciopago",
            text: "Mayo",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "juniopreciopago",
            text: "Junio",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },
        {
            dataField: "juliopreciopago",
            text: "Julio",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter2,
            headerFormatter: headFormatter
        },


    ];


    var total = props.getColegiaturasList.length;

    return (

        <Container>

            {
                props.getColegiaturasList ? (
                    <ToolkitProvider
                        bootstrap4
                        keyField="idcolegiatura"
                        data={props.getColegiaturasList}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                    >
                        {(props) => (
                            <div>
                                <Row>
                                    <Col>
                                        <div className="float-right">
                                            <SearchBar {...props.searchProps} placeholder="Buscar En Lista .." />
                                        </div>
                                    </Col>
                                </Row>

                                <BootstrapTable
                                    className="table table-sm table-hover table-striped table-vcenter mb-0 text-nowrap"
                                    keyField="idcolegiatura"
                                    {...props.baseProps}
                                    pagination={paginationFactory(
                                        {
                                            showTotal: true, // display pagination information
                                            sizePerPageList: [
                                                {
                                                    text: '50', value: 50
                                                },
                                                {
                                                    text: '100', value: 100
                                                },
                                                {
                                                    text: 'Todos', value: total
                                                }
                                            ],
                                            firstPageText: 'Primero', // the text of first page button
                                            prePageText: 'Previo', // the text of previous page button
                                            nextPageText: 'Siguiente', // the text of next page button
                                            lastPageText: 'Ultimo', // the text of last page button
                                            nextPageTitle: 'Ir Siguiente', // the title of next page button
                                            prePageTitle: 'Ir Previo', // the title of previous page button
                                            firstPageTitle: 'Ir Primero', // the title of first page button
                                            lastPageTitle: 'Ir Ultimo', // the title of last page button
                                        }
                                    )
                                    }
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                ) :
                (
                    <div className="text-center">
                        {props.errorColegiaturasList ? (
                            <h4>{props.errorColegiaturasList}</h4>
                        ) : (
                                <Spinner color="dark" />
                            )}
                    </div>
                )
           }
        </Container>

    );
};

export default withRouter(connect(mapStateToProps, null)(ColegiaturasTabla));

